import React, { Fragment, useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { resetPassword } from "../../store/user";
import { Box, Button, TextField, Typography } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { Formik, ErrorMessage } from "formik";
import { resetPasswordSchema } from "./reset-password-schema";
import logo from "../../Images/medsleep-logo.jpg";
import { history } from "../../utils/history";
import auth from "../../services/authService";
import { toast } from "react-toastify";

const useStyles = makeStyles((theme) => ({
  logo: theme.logo,
  message: {
    marginTop: "1rem",
    marginBottom: "1rem"
  }
}));

const ResetPassword = ({ ...props }) => {
  const classes = useStyles();

  useEffect(() => {
    const init = () => {};
    init();
  }, []);

  const onSubmit = async (values) => {

    const {resetPassword} = props;
    const token = auth.getCurrentUser();
    
    try{
      await resetPassword(token.primarysid,values.newPassword);
      toast.success("Password updated successfully!");
      history.push("/patient-dashboard");
    }
    catch(ex){
      toast.error("Failed to update password!");
    }

  };

  return (
    <Fragment>
      <Box
        sx={{
          minHeight: "calc(100vh - 180px)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          py: 4,
        }}
      >
        <Formik
          initialValues={{ newPassword: "", confirmNewPassword: "" }}
          validationSchema={resetPasswordSchema}
          onSubmit={(values) => {
            onSubmit(values);
          }}
          render={({
            values,
            setFieldValue,
            handleChange,
            handleSubmit,
            handleBlur,
            errors,
            touched,
            ...formProps
          }) => (
            <Box
              component="form"
              onSubmit={handleSubmit}
              sx={{ width: "100%", maxWidth: 450 }}
            >
              <Box sx={{ textAlign: "center", mb: 2 }}>
                <img src={logo} className={classes.logo} alt="MedSleep" />
              </Box>
              <Typography className={classes.message}>
                Your account was setup with a temporary password and/or was
                updated by administrator staff. Please enter a new password to
                continue.
              </Typography>
              <TextField
                error={errors.newPassword && touched.newPassword ? true : false}
                name="newPassword"
                type="password"
                label="New Password"
                margin="normal"
                fullWidth
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.newPassword}
              />
              <ErrorMessage name="newPassword">
                {(msg) => <div className="error error-message" dangerouslySetInnerHTML={{__html: msg}} />}
              </ErrorMessage>
              <TextField
                error={errors.confirmNewPassword && touched.confirmNewPassword ? true : false}
                name="confirmNewPassword"
                type="password"
                label="Confirm New Password"
                margin="normal"
                fullWidth
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.confirmNewPassword}
              />
              <ErrorMessage name="confirmNewPassword">
                {(msg) => <div className="error error-message">{msg}</div>}
              </ErrorMessage>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                sx={{ mt: 2 }}
              >
                Continue
              </Button>
            </Box>
          )}
        />
      </Box>
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    ...bindActionCreators({ resetPassword }, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);
